// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/purchase-orders/$orderId')({})
